var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"z-table-col z-table-col--body",attrs:{"colspan":_vm.colspan}},[(_vm.responsive)?_c('span',{staticClass:"z-table-col__title",domProps:{"innerHTML":_vm._s(_vm.data[_vm.index])}}):_vm._e(),_vm._v(" "),_c('span',{class:[
            'z-table-col__content',
            ( _obj = {}, _obj[("z-table-col__content--" + _vm.color)] = _vm.color, _obj )
        ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }